import { useCallback } from "react";

import { useQueryString } from "modules/core/hooks/useQueryString";

export const useActiveIdea = () => {
  const { urlQueries, overrideQS, removeFromQS } = useQueryString();

  const ideaId = urlQueries.idea as string | undefined;

  const setActiveIdea = useCallback(
    (ideaId: string) => {
      overrideQS({
        queryObject: {
          ...urlQueries,
          idea: ideaId
        }
      });
    },
    [overrideQS, urlQueries]
  );

  const resetActiveIdea = useCallback(() => {
    removeFromQS({ keys: ["idea"] });
  }, [removeFromQS]);

  return { ideaId, setActiveIdea, resetActiveIdea };
};
